function Divider() {
  return <div className="border-t-2 my-4"></div>;
}

export default Divider;
